import { styled, Tooltip, type TooltipProps, tooltipClasses } from "@mui/material";

interface ExtendedTooltipProps extends TooltipProps {
  force?: boolean;
}

const WhiteTooltip = styled(
  ({ className, force, ...props }: ExtendedTooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  )
)(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor:
      "light-dark(var(--mui-palette-common-white), var(--mui-palette-common-black))",
    color:
      "light-dark(var(--mui-palette-text-primary), var(--mui-palette-text-light))",
    boxShadow: theme.shadows[10],
    padding: 15,
    border: "1px solid",
    borderColor: "light-dark(transparent, var(--mui-palette-neutral-dark))",
  },
  [`& .${tooltipClasses.arrow}`]: {
    color:
      "light-dark(var(--mui-palette-common-white), var(--mui-palette-neutral-dark))",
  },
}));

export default WhiteTooltip;
